<div class="kaveri-generate-builder">
  <div class="kg-card" [class.kg-scanning]="isProcessing">
    <div class="kg-card-header">
      <mat-icon>account_tree</mat-icon>
      <span>Repository &amp; Workspace Configuration</span>
    </div>

    <div class="kg-form-grid">
      <div class="kg-form-group">
        <label class="kg-label" for="kgRepo">Target Repository</label>
        <div class="kg-select" [class.is-open]="openDropdown === 'repository'" (click)="$event.stopPropagation()">
          <button id="kgRepo" class="kg-select-trigger" type="button" (click)="toggleDropdown($event, 'repository')">
            <span>{{ selectedRepositoryLabel }}</span>
            <mat-icon>expand_more</mat-icon>
          </button>
          <div class="kg-select-menu" *ngIf="openDropdown === 'repository'">
            <button
              class="kg-select-option"
              type="button"
              *ngFor="let repo of repositories"
              [class.is-selected]="form.repository === repo.value"
              (click)="selectRepository($event, repo.value)"
            >
              <mat-icon>{{ form.repository === repo.value ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
              <span>{{ repo.label }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="kg-form-group">
        <label class="kg-label" for="kgBaseBranch">Base Branch</label>
        <div class="kg-select" [class.is-open]="openDropdown === 'baseBranch'" [class.is-disabled]="branchesLoading" (click)="$event.stopPropagation()">
          <button id="kgBaseBranch" class="kg-select-trigger" type="button" [disabled]="branchesLoading" (click)="toggleDropdown($event, 'baseBranch')">
            <span>{{ selectedBaseBranchLabel }}</span>
            <mat-icon>expand_more</mat-icon>
          </button>
          <div class="kg-select-menu" *ngIf="openDropdown === 'baseBranch'">
            <button
              class="kg-select-option"
              type="button"
              *ngFor="let branch of branches"
              [class.is-selected]="form.baseBranch === branch"
              (click)="selectBaseBranch($event, branch)"
            >
              <mat-icon>{{ form.baseBranch === branch ? 'check_circle' : 'account_tree' }}</mat-icon>
              <span>{{ branch }}</span>
            </button>
            <div class="kg-select-empty" *ngIf="!branches.length">No branches available</div>
          </div>
        </div>
      </div>

      <div class="kg-form-group">
        <label class="kg-label" for="kgNewBranch">New Branch Name</label>
        <input id="kgNewBranch" class="kg-control" type="text" placeholder="e.g. feature/order-api" [(ngModel)]="form.newBranchName" />
      </div>

      <div class="kg-form-group">
        <label class="kg-label" for="kgServiceName">Service Name (Optional)</label>
        <input id="kgServiceName" class="kg-control" type="text" placeholder="e.g. order-service" [(ngModel)]="form.serviceName" />
      </div>

      <div class="kg-form-group">
        <label class="kg-label" for="kgTbrdFile">TBRD YAML (Required for code)</label>
        <input id="kgTbrdFile" class="kg-control kg-file-control" type="file" [attr.accept]="acceptedTbrdFileTypes" (change)="onTbrdFileSelected($event)" />
        <span class="kg-file-name" *ngIf="tbrdFile">
          <mat-icon>description</mat-icon>
          {{ tbrdFile.name }}
        </span>
      </div>
    </div>
  </div>

  <div class="kg-actions">
    <button class="kg-primary-action" type="button" [disabled]="!canProceed" (click)="proceedToCodeGeneration()" [class.kg-proceeding]="isProcessing">
      <mat-icon>arrow_forward</mat-icon>
      Proceed to Code Generation
    </button>
    <span class="kg-status" *ngIf="processingStatusText">
      <span class="kg-status-dot"></span>
      {{ processingStatusText }}
    </span>
  </div>

  <div class="kg-progress-track" *ngIf="isProcessing">
    <div class="kg-progress-fill"></div>
  </div>

  <div class="kg-results" *ngIf="generatedMaps.length">
    <div class="kg-results-heading">
      <span class="kg-kicker">Generated outputs</span>
      <strong>{{ generatedMaps.length }} map{{ generatedMaps.length === 1 ? '' : 's' }}</strong>
    </div>
    <div class="kg-result-card" *ngFor="let map of generatedMaps">
      <div class="kg-result-header">
        <span class="kg-badge" [class]="'kg-badge-' + map.type">{{ map.type.toUpperCase() }}</span>
        <span class="kg-result-title">{{ map.title }}</span>
      </div>
      <pre class="kg-result-content">{{ map.content }}</pre>
    </div>
  </div>
</div>
